export interface EvidencePhoto {
  id: number;
  src: string;
  serviceItemId: number;
  serviceItemName: string;
}

export const ADDITIONAL_PHOTOS_LABEL = 'Additional photos';

export interface SystemGroup<T> {
  serviceItemId: number;
  label: string;
  items: T[];
}

export const groupBySystem = <T>(
  entries: T[],
  getServiceItemId: (entry: T) => number,
  getServiceItemName: (entry: T) => string,
): SystemGroup<T>[] => {
  const order: number[] = [];
  const byId = new Map<number, SystemGroup<T>>();
  for (const entry of entries) {
    const name = (getServiceItemName(entry) || '').trim();
    const rawSid = getServiceItemId(entry);
    const sid = rawSid > 0 && name !== '' ? rawSid : 0;
    let group = byId.get(sid);
    if (!group) {
      group = { serviceItemId: sid, label: sid === 0 ? ADDITIONAL_PHOTOS_LABEL : name, items: [] };
      byId.set(sid, group);
      order.push(sid);
    }
    group.items.push(entry);
  }
  const named = order
    .filter((sid) => sid !== 0)
    .map((sid) => byId.get(sid))
    .filter((group): group is SystemGroup<T> => group !== undefined);
  const additional = byId.get(0);
  return additional ? [...named, additional] : named;
};

export interface EvidenceSystemGroup {
  serviceItemId: number;
  label: string;
  photos: EvidencePhoto[];
}

export const groupEvidencePhotosBySystem = (photos: EvidencePhoto[]): EvidenceSystemGroup[] =>
  groupBySystem(
    photos,
    (photo) => photo.serviceItemId,
    (photo) => photo.serviceItemName,
  ).map(({ serviceItemId, label, items }) => ({ serviceItemId, label, photos: items }));
